import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

export function usePrevious(value: any) {
  const ref = useRef(undefined);
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

export const useHashFragment = (hash: string): [boolean, () => void] => {
  const [isActive, setIsActive] = useState(location.hash === hash);

  useEffect(() => {
    setIsActive(location.hash === hash);
  // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useEffect has an unnecessary dependency: location.
  }, [location.hash, hash]);

  const toggleHashFragment = isActive
    ? () => {
        location.hash = '';
      }
    : () => {
        location.hash = hash;
      };

  return [isActive, toggleHashFragment];
};

export function useIsPayacaAdmin(): boolean {
  return useSelector(
    (state: any) => state.users.myProfile.isPayacaAdmin as boolean
  );
}
